import { render } from "./NotificationCard.vue?vue&type=template&id=72ad9766&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import "./NotificationCard.vue?vue&type=style&index=0&id=72ad9766&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ad9766"]])

export default __exports__